/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MeetingStatusType,
    MeetingStatusTypeFromJSON,
    MeetingStatusTypeFromJSONTyped,
    MeetingStatusTypeToJSON,
} from './';

/**
 * Response object containing the current status of a meeting.
 * @export
 * @interface CheckMeetingStatusResponse
 */
export interface CheckMeetingStatusResponse {
    /**
     * The UUID of the meeting
     * @type {string}
     * @memberof CheckMeetingStatusResponse
     */
    id: string;
    /**
     * 
     * @type {MeetingStatusType}
     * @memberof CheckMeetingStatusResponse
     */
    status: MeetingStatusType;
}

export function CheckMeetingStatusResponseFromJSON(json: any): CheckMeetingStatusResponse {
    return CheckMeetingStatusResponseFromJSONTyped(json, false);
}

export function CheckMeetingStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckMeetingStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': MeetingStatusTypeFromJSON(json['status']),
    };
}

export function CheckMeetingStatusResponseToJSON(value?: CheckMeetingStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': MeetingStatusTypeToJSON(value.status),
    };
}


